import { render, staticRenderFns } from "./link-embed.vue?vue&type=template&id=e819a614&scoped=true&"
import script from "./link-embed.vue?vue&type=script&lang=js&"
export * from "./link-embed.vue?vue&type=script&lang=js&"
import style0 from "./link-embed.vue?vue&type=style&index=0&id=e819a614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e819a614",
  null
  
)

export default component.exports